import * as React from 'react'

function SvgKn(props) {
	return (
		<svg viewBox="0 0 750 500" width="1em" height="1em" {...props}>
			<defs>
				<clipPath id="kn_svg__a">
					<path fill="none" d="M0 0h750v500H0z" />
				</clipPath>
			</defs>
			<g clipPath="url(#kn_svg__a)">
				<path d="M750 0H0v500" fill="#009e49" />
				<path d="M0 500h750V0" fill="#ce1126" />
				<path d="M0 500L750 0" stroke="#fcd116" strokeWidth={210} />
				<path d="M0 500L750 0" stroke="#000" strokeWidth={150} />
				<g id="kn_svg__d" transform="rotate(-33.69 514.716 -777.095)" fill="#fff">
					<g id="kn_svg__c">
						<path id="kn_svg__b" d="M0-70V0h35" transform="rotate(18 0 -70)" />
						<use xlinkHref="#kn_svg__b" transform="scale(-1 1)" />
					</g>
					<use xlinkHref="#kn_svg__c" transform="rotate(72)" />
					<use xlinkHref="#kn_svg__c" transform="rotate(144)" />
					<use xlinkHref="#kn_svg__c" transform="rotate(216)" />
					<use xlinkHref="#kn_svg__c" transform="rotate(288)" />
				</g>
				<use xlinkHref="#kn_svg__d" transform="translate(-285 190)" />
			</g>
		</svg>
	)
}

export default SvgKn
